import { render } from "./Cabinets.vue?vue&type=template&id=67c52003"
import script from "./Cabinets.vue?vue&type=script&lang=js"
export * from "./Cabinets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__